import { axInst, axInstBasic } from "../../components/Service/Service";

export const fetchData = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getSearchData`,
            payload
        );
        // console.log("Response data:", res.data);
        return res.data.result;
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);
        throw error;
    }
};

export const fetchDataTable = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getChild`,
            payload
        );
        // console.log("Response data:", res.data);
        return res.data.result;
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);
        throw error;
    }
};


export const fetchaddArn = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}getFilterData`,
            payload
        );
        // console.log("Response data:", res.data);
        return res.data.result;
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);
        throw error;
    }
};

export const fetchsubmittable = async (payload) => {
    try {
        const res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}childrenShow`,
            payload
        );
        // console.log("Response data:", res.data);
        return res.data.result;
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);
        throw error;
    }
};

export const fetchnewarn = async (payload) => {
    try {
        const token = payload.userDetailsToken ||
            localStorage.getItem('token')
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const requestPayload = {
            ...payload,
            userDetailsToken: token
        };

        // console.log("API Request payload:", requestPayload);

        const res = await axInst.post(
            `${process.env.REACT_APP_API_URL}insertChildren`,
            requestPayload
        );

        // console.log("Response data:", res.data);
        return res.data.result;
    } catch (error) {
        console.error("Error fetching data:", error.response?.data || error.message);

    }
};






